import React from 'react';

export const PrimaryContent = ({ children }) => (
  <div className="xl:w-2/3 xl:mr-4 w-full flex flex-col flex-grow-2 justify-start items-stretch h-full">
    { children }
  </div>
)

export default PrimaryContent;
